export default {"src":"/_next/static/media/check_icon_filled_dark.e13e4a10.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};